// extracted by mini-css-extract-plugin
var _1 = "actual__zToES";
var _2 = "backgroundDecor__SN5_2";
var _3 = "bannerSection__pyAPw";
var _4 = "bullet__Ff68E";
var _5 = "calculator__DaL0N";
var _6 = "calculatorWrapper__WCN2G";
var _7 = "container__aLk16";
var _8 = "decorImage__A6yGx";
var _9 = "footnote__OlGDG";
var _a = "leftSide__wvYzo";
var _b = "rightSide__vE_VX";
var _c = "title__r52IB";
export { _1 as "actual", _2 as "backgroundDecor", _3 as "bannerSection", _4 as "bullet", _5 as "calculator", _6 as "calculatorWrapper", _7 as "container", _8 as "decorImage", _9 as "footnote", _a as "leftSide", _b as "rightSide", _c as "title" }
export default { "actual": _1, "backgroundDecor": _2, "bannerSection": _3, "bullet": _4, "calculator": _5, "calculatorWrapper": _6, "container": _7, "decorImage": _8, "footnote": _9, "leftSide": _a, "rightSide": _b, "title": _c }
